var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userInfo.responseCode === '00')?_c('div',{staticClass:"page-wrapper"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }